
export default {
   name: 'SpinnerBtn',
   props: {
      loading: {
         type: Boolean,
         default: false
      }
   },
   methods: {
      onclick() {
         if (this.loading) {
            return;
         }
         this.$emit('click');
      }
   }
};
